/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toggle_Fullscreen_ModeInputs */



/**
* | output |
* | --- |
* | "Toggle fullscreen mode" |
*
* @param {Toggle_Fullscreen_ModeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const toggle_fullscreen_mode = /** @type {((inputs?: Toggle_Fullscreen_ModeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toggle_Fullscreen_ModeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Basculer le mode plein écran")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vollbildmodus umschalten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Attiva/disattiva la modalità a schermo intero")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Переключить полноэкранный режим")
	if (locale === "es") return /** @type {LocalizedString} */ ("Activar o desactivar el modo de pantalla completa")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("切换全屏模式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("全画面モードを切り替える")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ुलस्क्रीन मोड चालू/बंद करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alternar modo de tela cheia")
	return /** @type {LocalizedString} */ ("Toggle fullscreen mode")
});